/**
 *
 *
 *
 *   EDITING THIS FILE REQUIRES EDITS TO EMAIL TEMPLATE PROJECT REPO FILE AS WELL TO KEEP THEM IN SYNC
 *
 *
 *
 *
 */

import {LOCALES} from '@utils/locales/locales';

export const PRETRAVEL_TEMPLATE_DEFAULTS = {
  [LOCALES.EN]: {
    subject: 'Pre Travel Notification',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Pre Travel Notification',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>You are scheduled to travel to the below destination(s). Please see the latest Travel Advice for these destinations along with any active alerts.</div><div><br></div><div>You are receiving this notification because your organization has opted you into receiving pre travel notifications. For further questions about this notification please contact your organization’s travel risk management team or submit a request for information to <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.FR]: {
    subject: 'Notification préalable au voyage',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notification préalable au voyage',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Vous devez vous rendre à la ou aux destinations ci-dessous. Vous trouverez ci-dessous les derniers conseils aux voyageurs pour ces destinations ainsi que les alertes actives.</div><div><br></div><div>Vous recevez cette notification parce que votre organisation a choisi de recevoir des notifications avant le voyage. Pour toute autre question concernant cette notification, veuillez contacter l\'équipe de gestion des risques liés aux voyages de votre organisation ou envoyer une demande d\'informations à <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.ES]: {
    subject: 'Notificación previa al viaje',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificación previa al viaje',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Tiene previsto viajar a los siguientes destinos. A continuación encontrará los consejos de viaje más recientes para estos destinos junto con las alertas activas.</div><div><br></div><div>Está recibiendo esta notificación porque su organización ha optado por que reciba notificaciones previas al viaje. Si tienes más preguntas sobre esta notificación, ponte en contacto con el equipo de gestión de riesgos de viaje de tu organización o envía una solicitud de información a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.DE]: {
    subject: 'Benachrichtigung vor Reiseantritt',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Benachrichtigung vor Reiseantritt',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Es ist geplant, dass Sie zu den unten aufgeführten Zielen reisen. Nachfolgend finden Sie die neuesten Reisehinweise für diese Reiseziele sowie alle aktiven Benachrichtigungen.</div><div><br></div><div>Sie erhalten diese Benachrichtigung, weil Ihre Organisation sich dafür entschieden hat, Benachrichtigungen vor Reiseantritt zu erhalten. Bei weiteren Fragen zu dieser Benachrichtigung wenden Sie sich bitte an das Reiserisikomanagementteam Ihrer Organisation oder senden Sie eine Informationsanfrage an <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.IT]: {
    subject: 'Notifica prima del viaggio',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notifica prima del viaggio',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>È previsto un viaggio verso le seguenti destinazioni. Di seguito sono riportati i consigli di viaggio più recenti per queste destinazioni insieme a eventuali avvisi attivi.</div><div><br></div><div>Stai ricevendo questa notifica perché la tua organizzazione ti ha scelto di ricevere notifiche prima del viaggio. Per ulteriori domande su questa notifica, contatta il team di gestione del rischio di viaggio della tua organizzazione o invia una richiesta di informazioni a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.JA]: {
    subject: '旅行前の通知',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '旅行前の通知',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>以下の目的地へのご旅行が予定されています。これらの目的地に関する最新の旅行アドバイスとアクティブなアラートを以下でご覧ください。</div><div><br></div><div>この通知を受け取るのは、所属する組織が旅行前通知の受信を選択しているためです。この通知についてさらに質問がある場合は、組織の旅行リスク管理チームに連絡するか、 <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> に情報提供のリクエストを送信してください。</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.PT]: {
    subject: 'Notificação antes da viagem',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificação antes da viagem',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Você está programado para viajar para o (s) destino (s) abaixo. Veja abaixo os conselhos de viagem mais recentes para esses destinos, juntamente com todos os alertas ativos.</div><div><br></div><div>Você está recebendo essa notificação porque sua organização optou por receber notificações pré-viagem. Para mais perguntas sobre essa notificação, entre em contato com a equipe de gerenciamento de riscos de viagem da sua organização ou envie uma solicitação de informações para <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.ZH_HANS]: {
    subject: '旅行前通知',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '旅行前通知',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>您计划前往以下目的地。请在下面找到这些目的地的最新旅行建议以及任何有效的警报。</div><div><br></div><div>您之所以收到此通知，是因为您的组织已选择您接收旅行前通知。有关此通知的更多问题，请联系贵组织的差旅风险管理团队或向 <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> 提交信息请求。</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.ZH_HANT]: {
    subject: '旅遊前通知',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '旅遊前通知',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>你預定前往以下目的地。請在下面找到這些目的地的最新旅遊建議以及任何有效警報。</div><div><br></div><div>您收到此通知是因為您的組織已選擇您接收出發前通知。如需有關此通知的進一步問題，請聯絡貴公司的旅遊風險管理團隊，或將資訊請求提交至 <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>。</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.NL]: {
    subject: 'Melding voorafgaand aan de reis',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Melding voorafgaand aan de reis',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Het is de bedoeling dat u naar de onderstaande bestemming (en) reist. Hieronder vindt u het laatste reisadvies voor deze bestemmingen, samen met eventuele actieve meldingen.</div><div><br></div><div>Je ontvangt deze melding omdat je organisatie ervoor heeft gekozen om meldingen vóór de reis te ontvangen. Voor verdere vragen over deze melding kunt u contact opnemen met het team voor reisrisicobeheer van uw organisatie of een verzoek om informatie indienen bij <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.HI]: {
    subject: 'यात्रा से पहले की सूचना',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'यात्रा से पहले की सूचना',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>आप नीचे दिए गए गंतव्यों की यात्रा करने के लिए निर्धारित हैं। कृपया किसी भी सक्रिय अलर्ट के साथ इन गंतव्यों के लिए नवीनतम यात्रा सलाह नीचे देखें।</div><div><br></div><div>आपको यह सूचना इसलिए मिल रही है क्योंकि आपके संगठन ने आपको यात्रा पूर्व सूचनाएं प्राप्त करने का विकल्प चुना है। इस सूचना के बारे में और प्रश्नों के लिए कृपया अपने संगठन की यात्रा जोखिम प्रबंधन टीम से संपर्क करें या <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> पर जानकारी के लिए अनुरोध सबमिट करें।</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.RU]: {
    subject: 'Уведомление перед поездкой',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Уведомление перед поездкой',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Вы планируете отправиться в указанные ниже пункты назначения. Ниже вы найдете последние рекомендации по путешествиям по этим направлениям, а также все активные уведомления.</div><div><br></div><div>Вы получили это уведомление, потому что ваша организация разрешила вам получать предварительные уведомления о поездках. Если у вас возникнут дополнительные вопросы по этому уведомлению, обратитесь в отдел управления туристическими рисками вашей организации или отправьте запрос на получение информации по адресу <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.PL]: {
    subject: 'Powiadomienie przed podróżą',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Powiadomienie przed podróżą',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Planowana jest podróż do poniższych miejsc docelowych. Poniżej znajdują się najnowsze porady dotyczące podróży do tych miejsc docelowych wraz z wszelkimi aktywnymi alertami.</div><div><br></div><div>Otrzymujesz to powiadomienie, ponieważ Twoja organizacja zdecydowała się na otrzymywanie powiadomień przed podróżą. W przypadku dalszych pytań dotyczących tego powiadomienia skontaktuj się z zespołem zarządzania ryzykiem podróży w organizacji lub prześlij prośbę o informacje na adres <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.HE]: {
    subject: 'הודעה לפני נסיעה',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'הודעה לפני נסיעה',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;שם פרטי&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;שם משפחה&gt;</span></span>,</div><div><br></div><div>אתה אמור לנסוע ליעד (ים) שלהלן. אנא עיין בעצות הנסיעות העדכניות ביותר עבור יעדים אלה יחד עם כל התראות פעילות.</div><div><br></div><div>אתה מקבל הודעה זו מכיוון שהארגון שלך בחר לקבל התראות לפני הנסיעה. לשאלות נוספות בנוגע להודעה זו אנא פנה לצוות ניהול סיכוני הנסיעות של הארגון שלך או שלח בקשה לקבלת מידע לכתובת <a href="mailto:support@crisis24.com">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.TR]: {
    subject: 'Seyahat Öncesi Bildirim',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Seyahat Öncesi Bildirim',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Aşağıdaki varış noktalarına seyahat etmeniz planlanıyor. Lütfen aktif uyarılarla birlikte bu destinasyonlar için en son Seyahat Önerilerine bakın.</div> <div></div><br><div>Kuruluşunuz seyahat öncesi bildirimleri almayı seçtiği için bu bildirimi alıyorsunuz. Bu bildirimle ilgili başka sorularınız için lütfen kuruluşunuzun seyahat riski yönetimi ekibiyle iletişime geçin veya <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com adresine bir bilgi talebi gönderin</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.KO]: {
    subject: '여행 전 알림',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '여행 전 알림',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>아래 목적지로 여행할 예정입니다.현재 진행 중인 알림과 함께 해당 목적지에 대한 최신 여행 안내를 참조하십시오.</div><div></div><br><div>조직에서 여행 전 알림 수신을 선택했기 때문에 이 알림을 받는 것입니다.이 알림에 대한 추가 질문은 조직의 여행 위험 관리팀에 문의하거나 <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> 으로 정보 요청을 제출하십시오</div>.',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.EL]: {
    subject: 'Ειδοποίηση πριν από το ταξίδι',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Ειδοποίηση πριν από το ταξίδι',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Έχετε προγραμματίσει να ταξιδέψετε στους παρακάτω προορισμούς. Ανατρέξτε στις πιο πρόσφατες ταξιδιωτικές συμβουλές για αυτούς τους προορισμούς μαζί με τυχόν ενεργές ειδοποιήσεις.</div> <div></div><br><div>Λαμβάνετε αυτήν την ειδοποίηση επειδή ο οργανισμός σας έχει επιλέξει να λαμβάνετε ειδοποιήσεις πριν από το ταξίδι. Για περισσότερες ερωτήσεις σχετικά με αυτήν την ειδοποίηση, επικοινωνήστε με την ομάδα διαχείρισης ταξιδιωτικών κινδύνων του οργανισμού σας ή υποβάλετε αίτημα για πληροφορίες στο <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.VI]: {
    subject: 'Thông báo trước khi đi du lịch',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Thông báo trước khi đi du lịch',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div> Bạn</div> <br><div>dự định đi du lịch đến (các) điểm đến dưới đây. Vui lòng xem Tư vấn Du lịch mới nhất cho các điểm đến này cùng với bất kỳ cảnh báo đang hoạt động nào.</div> <div></div><br><div>Bạn đang nhận được thông báo này vì tổ chức của bạn đã chọn bạn nhận thông báo trước chuyến đi. Nếu có thêm câu hỏi về thông báo này, vui lòng liên hệ với nhóm quản lý rủi ro du lịch của tổ chức bạn hoặc gửi yêu cầu cung cấp thông tin đến <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.CS]: {
    subject: 'Upozornění před cestou',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Upozornění před cestou',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Máte naplánovanou cestu do níže uvedených cílů. Podívejte se na nejnovější cestovní rady pro tyto destinace spolu s aktivními upozorněními.</div> <div></div><br><div>Toto oznámení obdržíte, protože vaše organizace vás rozhodla přijímat oznámení před cestou. Máte-li další dotazy týkající se tohoto oznámení, obraťte se na tým pro řízení cestovních rizik vaší organizace nebo požádejte o informace na adresu <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.HU]: {
    subject: 'Utazás előtti értesítés',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Utazás előtti értesítés',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> A <br><div>tervek szerint az alábbi úti célokra utazik. Kérjük, olvassa el ezekre az úti célokra vonatkozó legfrissebb utazási tanácsokat az aktív figyelmeztetésekkel együtt.</div> <div></div><br><div>Ezt az értesítést azért kapja meg, mert szervezete választotta Önt az utazás előtti értesítések fogadására. Ha további kérdései vannak ezzel az értesítéssel kapcsolatban, kérjük, vegye fel a kapcsolatot szervezete utazási kockázatkezelő csoportjával, vagy küldjön tájékoztatási kérelmet a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com címre</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.MS]: {
    subject: 'Pemberitahuan Pra-Perjalanan',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Pemberitahuan Pra-Perjalanan',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Anda dijadualkan untuk melancong ke destinasi di bawah. Sila lihat Nasihat Perjalanan terkini untuk destinasi ini bersama-sama dengan sebarang makluman aktif.</div> <div></div><br><div>Anda menerima pemberitahuan ini kerana organisasi anda telah memilih anda untuk menerima pemberitahuan pra-perjalanan. Untuk pertanyaan lanjut mengenai pemberitahuan ini sila hubungi pasukan pengurusan risiko perjalanan organisasi anda atau hantar permintaan maklumat kepada <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.RO]: {
    subject: 'Notificare înainte de călătorie',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificare înainte de călătorie',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>, Sun<div></div></div> <br><div>teți programat să călătoriți la destinația (destinațiile) de mai jos. Vă rugăm să consultați cele mai recente sfaturi de călătorie pentru aceste destinații împreună cu orice alerte active.</div> <div></div><br><div>Primiți această notificare deoarece organizația dvs. v-a optat să primiți notificări înainte de călătorie. Pentru întrebări suplimentare cu privire la această notificare, vă rugăm să contactați echipa de gestionare a riscurilor de călătorie a organizației dvs. sau să trimiteți o solicitare de informații la <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.SK]: {
    subject: 'Oznámenie pred cestou',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Oznámenie pred cestou',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Máte naplánovanú cestu do nižšie uvedených cieľov. Pozrite si najnovšie cestovné rady pre tieto destinácie spolu s aktívnymi upozorneniami.</div> <div></div><br><div>Toto oznámenie dostávate preto, lebo vaša organizácia vám povolila prijímať upozornenia pred cestou. V prípade ďalších otázok týkajúcich sa tohto oznámenia kontaktujte tím riadenia cestovných rizík vašej organizácie alebo odošlite žiadosť o informácie na <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">adresu support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.TH]: {
    subject: 'การแจ้งเตือนก่อนการเดินทาง',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'การแจ้งเตือนก่อนการเดินทาง',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>คุณมีกำหนดการเดินทางไปยังจุดหมายปลายทางด้านล่างโปรดดูคำแนะนำการเดินทางล่าสุดสำหรับจุดหมายปลายทางเหล่านี้พร้อมกับการแจ้งเตือนที่ใช้งานอยู่</div><div></div><br><div>คุณได้รับการแจ้งเตือนนี้เนื่องจากองค์กรของคุณเลือกให้คุณรับการแจ้งเตือนก่อนการเดินทางสำหรับคำถามเพิ่มเติมเกี่ยวกับการแจ้งเตือนนี้ โปรดติดต่อทีมบริหารความเสี่ยงในการเดินทางขององค์กรของคุณ หรือส่งคำขอข้อมูลไป <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">ที่ support@crisis24.com</a></div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.UK]: {
    subject: 'Повідомлення про попередню подорож',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Повідомлення про попередню подорож',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Ви плануєте подорожувати до наведених нижче пунктів призначення. Будь ласка, перегляньте останні поради щодо подорожей для цих напрямків разом із будь-якими активними сповіщеннями.</div> <div></div><br><div>Ви отримуєте це сповіщення, оскільки ваша організація вирішила отримувати сповіщення перед поїздкою. Для отримання додаткових запитань щодо цього повідомлення, будь ласка, зв\'яжіться з командою організації з управління ризиками подорожей або надішліть запит на отримання інформації на адресу <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.BG]: {
    subject: 'Предварително уведомление',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Предварително уведомление',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Планирано е да пътувате до посочената (и) дестинация (и) по-долу. Моля, намерете по-долу най-новите съвети за пътуване за тези дестинации заедно с всички активни сигнали.</div> <div></div><br><div>Получавате това уведомление, защото организацията ви е избрала да получавате известия преди пътуване. За допълнителни въпроси относно това уведомление, моля, свържете се с екипа за управление на риска при пътуване на вашата организация или подайте искане за информация на <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.FR_CA]: {
    subject: 'Avis préalable au voyage',
    components: [
      {order: 1, type: 'TITLE', html: 'Avis préalable au voyage'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Vous devez voyager vers la ou les destinations ci-dessous. Veuillez trouver ci-dessous les derniers conseils aux voyageurs pour ces destinations ainsi que toutes les alertes actives.</div><div><br></div><div>Vous recevez cet avis parce que votre organisation a choisi que vous receviez des avis préalables au voyage. Pour d\'autres questions au sujet de cet avis, veuillez communiquer avec l\'équipe de gestion des risques liés aux voyages de votre organisation ou soumettre une demande de renseignements à <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.EN_GB]: {
    subject: 'Pre Travel Notification',
    components: [
      {order: 1, type: 'TITLE', html: 'Pre Travel Notification'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>You are scheduled to travel to the below destination(s). Please find below the latest Travel Advice for these destinations along with any active alerts.</div><div><br></div><div>You are receiving this notification because your organization has opted you into receiving pre travel notifications. For further questions about this notification please contact your organization’s travel risk management team or submit a request for information to <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.AR]: {
    subject: 'إشعار ما قبل السفر',
    components: [
      {order: 1, type: 'TITLE', html: 'إشعار ما قبل السفر'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>،</div><div><br></div><div>من المقرر أن تسافر إلى الوجهة (الوجهات) التالية. يرجى الاطلاع أدناه على أحدث نصائح السفر لهذه الوجهات بالإضافة إلى أي تنبيهات نشطة.</div><div><br></div><div>أنت تتلقى هذا الإشعار لأن مؤسستك قد اختارتك لتلقي إشعارات ما قبل السفر. لمزيد من الأسئلة حول هذا الإشعار، يُرجى الاتصال بفريق إدارة مخاطر السفر في مؤسستك أو إرسال طلب للحصول على معلومات إلى <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.PT_BR]: {
    subject: 'Notificação de pré-viagem',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificação de pré-viagem'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Sua viagem está programada para o(s) destino(s) abaixo. Veja abaixo as últimas recomendações de viagem para esses destinos, juntamente com todos os alertas ativos.</div><div><br></div><div>Você está recebendo esta notificação porque sua organização optou por receber notificações prévias à viagem. Para obter mais informações sobre esta notificação, entre em contato com a equipe de gerenciamento de riscos de viagem da sua organização ou envie uma solicitação de informações para <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.SV]: {
    subject: 'Avisering före resa',
    components: [
      {order: 1, type: 'TITLE', html: 'Avisering före resa'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Du är planerad att resa till nedanstående destination(er). Nedan hittar du de senaste reserådgivningarna för dessa destinationer tillsammans med eventuella aktiva varningar.</div><div><br></div><div>Du får detta meddelande eftersom din organisation har valt att du ska få meddelanden före resan. För ytterligare frågor om detta meddelande, vänligen kontakta din organisations team för hantering av reserisker eller skicka en begäran om information till <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.FI]: {
    subject: 'Matkustamista edeltävä ilmoitus',
    components: [
      {order: 1, type: 'TITLE', html: 'Matkustamista edeltävä ilmoitus'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Teidän on määrä matkustaa alla olevaan kohteeseen (kohteisiin). Ohessa on viimeisimmät matkustusohjeet ja mahdolliset aktiiviset varoitukset.</div><div><br></div><div>Saat tämän ilmoituksen, koska organisaatiosi on valinnut sinut vastaanottamaan ilmoituksia ennen matkaa. Jos sinulla on lisäkysymyksiä tästä ilmoituksesta, ota yhteyttä organisaatiosi matkariskien hallintaryhmään tai lähetä tietopyyntö osoitteeseen <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.DA]: {
    subject: 'Meddelelse før rejsen',
    components: [
      {order: 1, type: 'TITLE', html: 'Meddelelse før rejsen'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Du skal efter planen rejse til nedenstående destination(er). Nedenfor finder du de seneste rejsevejledninger for disse destinationer sammen med eventuelle aktive advarsler.</div><div><br></div><div>Du modtager denne meddelelse, fordi din organisation har valgt, at du skal modtage meddelelser før rejsen. Hvis du har yderligere spørgsmål om denne meddelelse, bedes du kontakte din organisations travel risk management team eller sende en anmodning om oplysninger til <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.NO]: {
    subject: 'Varsling før reise',
    components: [
      {order: 1, type: 'TITLE', html: 'Varsling før reise'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Du skal etter planen reise til destinasjonen (e) nedenfor. Nedenfor finner du de siste reiserådene for disse destinasjonene sammen med eventuelle aktive varsler.</div><div><br></div><div>Du mottar dette varselet fordi organisasjonen din har valgt at du mottar varsler før reisen. For ytterligere spørsmål om dette varselet, vennligst kontakt organisasjonens reiserisikostyringsteam eller send en forespørsel om informasjon til <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.CA]: {
    subject: 'Notificació prèvia al viatge',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificació prèvia al viatge'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Està previst que viatgeu a la destinació (s) següents. Trobeu a continuació els últims consells sobre viatges per a aquestes destinacions juntament amb les alertes actives.</div><div><br></div><div>Estàs rebent aquesta notificació perquè la teva organització t\'ha optat per rebre notificacions prèvies al viatge. Per a més preguntes sobre aquesta notificació poseu-vos en contacte amb l\'equip de gestió de riscos de viatges de la vostra organització o envieu una sol·licitud d\'informació a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
  [LOCALES.ES_MX]: {
    subject: 'Notificación previa al viaje',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificación previa al viaje'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div><span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,</div><div><br></div><div>Está programado para viajar a los siguientes destinos. A continuación encontrará los últimos consejos de viaje para estos destinos junto con las alertas activas.</div><div><br></div><div>Está recibiendo esta notificación porque su organización ha optado por recibir notificaciones previas al viaje. Si tiene más preguntas sobre esta notificación, comuníquese con el equipo de gestión de riesgos de viaje de su organización o envíe una solicitud de información a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {
        order: 5,
        html: 'Destinations: city, country',
        includeLocationIntelligenceLinks: true,
        includeLocationCountryBriefLink: true,
        includeLocationCityBriefLink: true,
        type: 'DESTINATIONS',
      },
    ],
  },
};
